var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SettingsApiService from '../../Shared/services/SettingsApiService';
const configuration = [];
const getConfig = (settingKey, languagePath) => __awaiter(void 0, void 0, void 0, function* () {
    if (configuration.length !== 0) {
        return;
    }
    const settings = yield SettingsApiService.get(null, languagePath);
    switch (settingKey) {
        case 'search':
            Object.keys(settings['tx_zigsearch']).forEach(function (key) {
                configuration[key] = settings['tx_zigsearch'][key];
            });
            break;
        case 'project':
            Object.keys(settings['tx_zigsearch']).forEach(function (key) {
                configuration[key] = settings['tx_zigsearch'][key];
            });
            Object.keys(settings['tx_zigrealestate']['project']).forEach(function (key) {
                configuration[key] = settings['tx_zigrealestate']['project'][key];
            });
            break;
        case 'complex':
            Object.keys(settings['tx_zigsearch']).forEach(function (key) {
                configuration[key] = settings['tx_zigsearch'][key];
            });
            Object.keys(settings['tx_zigrealestate']['complex']).forEach(function (key) {
                configuration[key] = settings['tx_zigrealestate']['complex'][key];
            });
            break;
        case 'unit':
            Object.keys(settings['tx_zigsearch']).forEach(function (key) {
                configuration[key] = settings['tx_zigsearch'][key];
            });
            Object.keys(settings['tx_zigrealestate']['rentableUnit']).forEach(function (key) {
                configuration[key] = settings['tx_zigrealestate']['rentableUnit'][key];
            });
            break;
        default:
            throw new Error(`There is no config for this settingKey: ${settingKey}`);
    }
});
const SearchConfigurationService = {
    get: (param) => {
        return configuration[param];
    },
    init: (settingKey, languagePath) => __awaiter(void 0, void 0, void 0, function* () {
        yield getConfig(settingKey, languagePath);
    }),
};
export default SearchConfigurationService;
